<template>
    <div>
        <v-checkbox v-model="estimate.isCCar" label="Courtesy Car?" />
        <v-checkbox v-if="estimate.isCCar" v-model="estimate.ccTypeManual" label="Manual" />
        <v-checkbox v-if="estimate.isCCar" v-model="estimate.ccTypeAuto" label="Automatic" />
    </div>
</template>

<script>
    export default {
        name: "EstimateCourtesyCar",
        props: {
            estimate: Object
        }
    }
</script>

<style scoped>

</style>
